import { render, staticRenderFns } from "./ComponentConfigDialog.vue?vue&type=template&id=6664c4dc&"
import script from "./ComponentConfigDialog.vue?vue&type=script&lang=js&"
export * from "./ComponentConfigDialog.vue?vue&type=script&lang=js&"
import style0 from "./ComponentConfigDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports